export const MAP_RESET = 'MAP/RESET';
export const MAP_PAGE_INIT = 'MAP_PAGE/INIT';
export const MAP_CHANGE = 'MAP/CHANGE';
